/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Import_CsvInputs */



/**
* | output |
* | --- |
* | "Import CSV" |
*
* @param {Knp_Terms_Import_CsvInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_import_csv = /** @type {((inputs?: Knp_Terms_Import_CsvInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Import_CsvInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer CSV")
	if (locale === "de") return /** @type {LocalizedString} */ ("CSV importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa CSV")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт CSV")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar CSV")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入 CSV 文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CSVをインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CSV आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar CSV")
	return /** @type {LocalizedString} */ ("Import CSV")
});